export class SousService {
  id?: number;
  name?: string;
  namearabe?: string;          // Arabic name
  nameanglais?: string;        // English name – NEW
  website?: string;
  category?: string;
  categoryarab?: string;       // Arabic category (optional)
  categoryanglais?: string;    // English category (optional) – NEW
  image_url?: string;
  description?: string;
  descriptionarabe?: string;   // Arabic description
  descriptionanglais?: string; // English description – NEW
  prix?: string;
  video?: string;              // ✅ NEW : URL vidéo (nullable)
  listimages?: string[];
  // other fields if any
}